var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmotionsDisgusted = function SvgEmotionsDisgusted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "url(#emotions-disgusted_svg__a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M4.167 7.5c0-.46.373-.833.833-.833h2.5a.833.833 0 0 1 0 1.666H5a.833.833 0 0 1-.833-.833m2.5 7.5a3.333 3.333 0 0 1 6.666 0zM12.5 6.667a.833.833 0 0 0 0 1.666H15a.833.833 0 1 0 0-1.666z",
    clipRule: "evenodd",
    opacity: 0.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "emotions-disgusted_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(90 2.708 7.292)scale(15.4167)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#98e791"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3c9845"
  })))));
};
export default SvgEmotionsDisgusted;